@if (!isUsedInDialog) {
  <div class="row loren-period-selector-form">
    <div class="col-md-4">
      <loren-period-selector (periodChange)="handlePeriodChange($event)">
      </loren-period-selector>
    </div>
    @if (showFromTo) {
      <div class="col-md-2">
        <loren-date-field
          [field]="from"
          (fieldInteraction)="handleCustomPeriodSelection($event)">
        </loren-date-field>
      </div>
      <div class="col-md-2">
        <loren-date-field
          [field]="to"
          (fieldInteraction)="handleCustomPeriodSelection($event)">
        </loren-date-field>
      </div>
      <div class="col-md-2 timepicker-custom-mb12">
        <mat-form-field appearance="outline" class="loren-timepicker-field">
          <input
            matInput
            type="time"
            [ngModel]="lastSelectedTimeFrom"
            (ngModelChange)="
              lastSelectedTimeFrom = $event; prepareSelectedPeriod()
            " />
        </mat-form-field>
      </div>
      <div class="col-md-2 timepicker-custom-mb12">
        @if (timePickerEnabled) {
          <mat-form-field appearance="outline" class="loren-timepicker-field">
            <input
              matInput
              type="time"
              [ngModel]="lastSelectedTimeTo"
              (ngModelChange)="
                lastSelectedTimeTo = $event; prepareSelectedPeriod()
              " />
          </mat-form-field>
        }
      </div>
    }
  </div>
}

<!-- TODO extract dialog view in a separate component !-->

@if (isUsedInDialog) {
  <div class="row dialog-period-selector">
    <div class="col">
      <loren-period-selector (periodChange)="handlePeriodChange($event)">
      </loren-period-selector>
    </div>
  </div>
  @if (showFromTo) {
    <div class="row dialog-date-row">
      <div class="col">
        <loren-date-field
          [field]="from"
          (fieldInteraction)="handleCustomPeriodSelection($event)">
        </loren-date-field>
        <div class="dialog-time-picker">
          <mat-form-field appearance="outline" class="loren-timepicker-field">
            <input
              matInput
              type="time"
              [ngModel]="lastSelectedTimeFrom"
              (ngModelChange)="
                lastSelectedTimeFrom = $event; prepareSelectedPeriod()
              " />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row dialog-date-row">
      <div class="col">
        <loren-date-field
          [field]="to"
          (fieldInteraction)="handleCustomPeriodSelection($event)">
        </loren-date-field>
        <div class="dialog-time-picker">
          @if (timePickerEnabled) {
            <mat-form-field appearance="outline" class="loren-timepicker-field">
              <input
                matInput
                type="time"
                [ngModel]="lastSelectedTimeTo"
                (ngModelChange)="
                  lastSelectedTimeTo = $event; prepareSelectedPeriod()
                " />
            </mat-form-field>
          }
        </div>
      </div>
    </div>
  }
}
